import React from "react";
import { ITkMessageDialogPropTypes } from "../../../type/componentsType/TkMessageModal";
import TkDialog from "../../atoms/TkDialog";
import "./_style.scss";

/**
 * ダイアログ部品
 * @param {boolean} open true：ダイアログを開く。false：ダイアログを閉じる。
 * @param {function} onCancel キャンセルボタンを押下した場合のイベント
 * @param {function} onOky OKボタンを押下した場合のイベント
 * @param {string} title ダイアログのタイトル
 * @param {string} okText OKボタンのタイトル
 * @param {string} cancelText キャンセルボタンのタイトル
 * @return TkMessageDialog ダイアログ部品
 */
export const TkMessageDialog: React.FC<ITkMessageDialogPropTypes> = (props) => {
  const {
    open,
    onClose,
    onCancel,
    onOky,
    okText,
    cancelText,
    contextText,
    title,
    children,
  } = props;
  return (
    <TkDialog
      open={open || false}
      onClose={onClose}
      onCancel={onCancel}
      className="tkMessageDialog"
      contextText={contextText}
      title={title}
      onSave={onOky}
      cancelText={cancelText}
      okText={okText}
    >
      {children}
    </TkDialog>
  );
};

export default TkMessageDialog;
